export default __webpack_public_path__ + "locales/en/FormFillingTipsDialog.json?hash=869225c01d2491acb8462003c54891e2";